import type { BiTrackEventType } from '../types';

export const BiTrackService = Symbol('BiTrackService');

export interface BiTrackService {
    biTrack(eventType: string, eventdata: BiTrackEventType): Promise<boolean>;
}
